/**
 * Slash commands for Orion Console (parity with ERP).
 * /command -> resolved prompt text.
 * Keep in sync with frontend/src/constants/orionSlashCommands.js when adding or changing commands.
 */
export const SLASH_COMMANDS = {
  sales: `[Intent: sales_analysis][Scope: date=today] Explain today's sales performance: total revenue, invoice count, top-selling items.`,
  expenses: `[Intent: expense_summary][Scope: recent] Summarize recent expenses: total by period, breakdown by category, trends.`,
  inventory: `[Intent: anomaly_detection][Scope: recent_periods] Any inventory or stock issues? Low stock, anomalies?`,
  cash: `[Intent: expense_summary][Scope: recent] Summarize cash and expense trends.`,
  profitability: `[Intent: profitability][Scope: last_90_days] Use profitability analytics to answer: most profitable items, most profitable sales invoices, best suppliers/clients by profit, and losing items.`,
  topitems: `[Intent: profitability][Question: top_items] What items are most profitable? Show top items by gross profit and margin.`,
  topsuppliers: `[Intent: profitability][Question: top_suppliers] Which suppliers are most profitable to deal with and why?`,
  topclients: `[Intent: profitability][Question: top_clients] Which clients generated the most profit and why?`,
  losingitems: `[Intent: profitability][Question: losing_items] Which items are losing money (negative/lowest profit or margin) and why?`,
  report: `[Intent: sales_analysis][Scope: recent] Give a brief business report for the recent period.`,
  forecast: `[Intent: forecast][Scope: next_month] Brief forecast for next month: sales, expenses, cash flow.`,
  help: `List what you can do: sales analysis, expense summary, inventory check, cash summary, reports, and forecasts. Be concise.`,
};

const SLASH_ORDER = ['sales', 'expenses', 'inventory', 'cash', 'profitability', 'topitems', 'topsuppliers', 'topclients', 'losingitems', 'report', 'forecast', 'help'];

export function resolveSlashCommand(text) {
  const t = (text || '').trim();
  if (!t.startsWith('/')) return t;
  const cmd = t.slice(1).split(/\s/)[0].toLowerCase();
  return SLASH_COMMANDS[cmd] ?? t;
}

export function getSlashCommandName(text) {
  const t = (text || '').trim();
  if (!t.startsWith('/')) return null;
  const cmd = t.slice(1).split(/\s/)[0].toLowerCase();
  return SLASH_COMMANDS[cmd] != null ? cmd : null;
}

export function getSlashCommandListForHelp(isAr) {
  const list = SLASH_ORDER.map((c) => `/${c}`).join(isAr ? '، ' : ', ');
  return list;
}

const PLACEHOLDER_COMMANDS = ['sales', 'expenses', 'inventory'];
export function getPlaceholderSlashHint(isAr) {
  const part = PLACEHOLDER_COMMANDS.map((c) => `/${c}`).join(isAr ? '، ' : ', ');
  return `${part}…`;
}
